export function initProjectSliders() {
    var projectSwiper = new Swiper(".projects .projects__slider-img .swiper", {
        slidesPerView: 2,
        speed: 500,
        loop: true,
        pagination: {
            el: ".projects .projects__main .swiper-pagination",
            renderBullet: function (index, className) {
                return '<li class="' + className + '"><button></button></li>';
            },
            clickable: true,
        },
        navigation: {
            nextEl: ".projects .projects__main .btn-arrow--next",
            prevEl: ".projects .projects__main .btn-arrow--prev",
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                pagination: {
                    el: ".projects .projects__main .swiper-pagination-mobile",
                    type: "fraction",
                },
            },
            904: {
                slidesPerView: 1,
                pagination: {
                    el: ".projects .projects__main .swiper-pagination",
                    type: "bullets",
                    renderBullet: function (index, className) {
                        return '<li class="' + className + '"><button></button></li>';
                    },
                    clickable: true
                },
            },
            1240: {
                slidesPerView: 2
            }
        }
    });

    document.querySelectorAll('.projects .projects__slider-more .swiper').forEach((slider, index) => {
        var swiper = new Swiper(`.projects .projects__foot [data-id='${index + 1}'] .swiper`, {
            grabCursor: true,
            pagination: {
                el: `.projects .projects__foot [data-id='${index + 1}'] .swiper-pagination`,
                renderBullet: function (index, className) {
                    return '<li class="' + className + '"><button></button></li>';
                },
                clickable: true,
            },
            effect: "creative",
            creativeEffect: {
                limitProgress: 2,
            },
            breakpoints: {
                320: {
                    pagination: {
                        el: `.projects .projects__foot [data-id='${index + 1}'] .swiper-pagination-mobile`,
                        type: "fraction",
                    },
                    navigation: {
                        nextEl: `.projects .projects__foot [data-id='${index + 1}'] .btn-arrow--next`,
                        prevEl: `.projects .projects__foot [data-id='${index + 1}'] .btn-arrow--prev`,
                    },
                    creativeEffect: {
                        prev: {
                            shadow: false,
                            translate: [0, 0, -400],
                        },
                        next: {
                            translate: [15, 6, 0],
                        },
                    }
                },
                904: {
                    pagination: {
                        el: `.projects .projects__foot [data-id='${index + 1}'] .swiper-pagination`,
                        renderBullet: function (index, className) {
                            return '<li class="' + className + '"><button></button></li>';
                        },
                        clickable: true,
                    },
                    navigation: false,
                    creativeEffect: {
                        prev: {
                            shadow: true,
                            translate: [0, 0, -400],
                        },
                        next: {
                            translate: [20, 15, 0],
                        },
                    }
                },
                1240: {
                    creativeEffect: {
                        next: {
                            translate: [30, 20, 0],
                        },
                    }
                }
            }
        });
    })

    document.querySelectorAll('.projects  .projects__foot .list__item').forEach((item, index) => {
        item.querySelector('.btn-back').dataset.id = item.dataset.id;
    });
}
